// extracted by mini-css-extract-plugin
export default {"root":"gQFEg5VSzpS4SuqzfMw6"};